import LayoutAdminContent from "./LayoutAdminContent";
export default LayoutAdminContent;
